import styled from '@emotion/styled';
import { theme, media } from '@vfit/shared/themes';

export const PillsContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  row-gap: 10px;
  margin-top: ${theme.spacing.sm};

  & > div {
    margin-right: ${theme.spacing.sm};
  }

  ${media.tablet`
    margin-top: ${theme.spacing.lg};
  `}

  ${media.desktop`
    margin-top: ${theme.spacing.lg};
  `}
`;
